import { GOLD_COLOR, QUEST_PROGRAMS, QUEST_TYPES, formatPoints, formatTokenAmount } from '../../helpers/quests';

// Ступени награды Gold-задания для подписи
const goldParams = (quest) => ({
  target: quest.target,
  points: formatPoints(quest.basePoints),
  stretchTarget: quest.stretchTarget,
  stretchPoints: formatPoints(quest.stretchPoints),
});

// Заголовок и подзаголовок задания с учётом персональной цели и замены апгрейда на приглашение
export const getQuestText = (t, quest, week) => {
  const program = QUEST_PROGRAMS[quest.program]?.name;
  const isSubstitute = quest.type === QUEST_TYPES.UPGRADE && quest.effectiveType === QUEST_TYPES.INVITE;

  if (isSubstitute) {
    return {
      title: t('quests.items.substitute.title', { program }),
      subtitle: t('quests.items.substitute.subtitle', { program, level: 4 }),
    };
  }

  switch (quest.effectiveType) {
    case QUEST_TYPES.UPGRADE:
      return {
        title: t('quests.items.upgrade.title', {
          program,
          level: quest.targetLevel,
        }),
        subtitle: t('quests.items.upgrade.subtitle', { level: quest.minLevel }),
      };
    case QUEST_TYPES.INVITE:
      return {
        title: t('quests.items.invite.title', { level: quest.minLevel }),
        subtitle: t('quests.items.invite.subtitle', { level: quest.minLevel }),
      };
    case QUEST_TYPES.INVITE_MULTI:
      return {
        title: t('quests.items.inviteMulti.title', { count: quest.target }),
        subtitle: t('quests.items.inviteMulti.subtitle', {
          count: quest.target,
          level: quest.minLevel,
        }),
      };
    case QUEST_TYPES.HOLD:
      return {
        title: t('quests.items.hold.title', { usd: quest.holdUsd }),
        subtitle: t('quests.items.hold.subtitle', {
          amount: formatTokenAmount(week?.holdTokenAmount),
          days: quest.target,
        }),
      };
    case QUEST_TYPES.COMBO:
      return {
        title: t('quests.items.combo.title'),
        subtitle: t('quests.items.combo.subtitle', { level: quest.minLevel }),
      };
    case QUEST_TYPES.RECYCLE:
      return {
        title: t('quests.items.recycle.title'),
        subtitle: t('quests.items.recycle.subtitle', goldParams(quest)),
      };
    case QUEST_TYPES.GOLD_RECYCLE:
      return {
        title: t('quests.items.goldRecycle.title', { level: quest.minLevel }),
        subtitle: t('quests.items.goldRecycle.subtitle', {
          ...goldParams(quest),
          level: quest.minLevel,
        }),
      };
    case QUEST_TYPES.GOLD_TEAM:
      return {
        title: t('quests.items.goldTeam.title'),
        subtitle: t('quests.items.goldTeam.subtitle', {
          ...goldParams(quest),
          level: quest.minLevel,
        }),
      };
    default:
      return { title: '', subtitle: '' };
  }
};

export const getQuestColor = (quest) => {
  if (quest.isGold) return GOLD_COLOR;
  return quest.effectiveType === QUEST_TYPES.UPGRADE ? QUEST_PROGRAMS[quest.program]?.color : '#985AFF';
};
